// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#app{background-color:#f9fcff!important}.v-card__text,.v-card__title{word-break:normal!important}.card-shadow{box-shadow:0 2px 15px 0 rgba(0,0,0,.12)!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
